<template>
  <side-panel-inner>
    <header slot="header" class="c-panel__header-title">
      <h2 class='u-hide-mobile'>Edit Profile</h2>
    </header>

    <template slot="actions">
      <base-button success :primary="true" @click="updateProfile">Save</base-button>
    </template>

    <loading v-if="loading" />
    <form method="post" v-on:submit.prevent="updateProfile" v-else>
      <section v-if="section === 'details'">
        <form-field
          full-width
          label="Name"
          name="name"
          type="text"
          v-model="currentUser.name"
          helperText="Note: On changing your name, the system will need to re-validate you."
          required
        ></form-field>
        <form-field
          full-width
          label="Position"
          name="position"
          type="text"
          v-model="currentUser.position"
        ></form-field>
        <form-field
          full-width
          label="Department"
          name="department"
          type="text"
          v-model="currentUser.department"
        ></form-field>
        <form-field
          full-width
          label="Location"
          name="location"
          type="text"
          v-model="currentUser.location"
        ></form-field>
        <form-field
          full-width
          label="Avatar"
          name="avatar"
          helperText="Please keep images to 200 pixels wide by 200 pixels high"
        >
          <file-upload
            name="avatar"
            @uploaded="onFileUploaded"
            resource="content"
            :bypassDuplicate="true"
            :fileTypes="['png','jpg']"
            v-model="currentUser.avatar"
          ></file-upload>
        </form-field>
      </section>
      <section v-else-if="section === 'bio'">
        <quill-editor
          :options="quillEditorOptions"
          v-model="currentUser.bio"
          @focus="handleQuillFocus"
          @input="handleQuillInput"
        ></quill-editor>
      </section>
      <section v-else-if="section === 'specialisms'">
        <quill-editor
          :options="quillEditorOptions"
          v-model="currentUser.specialism"
          @focus="handleQuillFocus"
          @input="handleQuillInput"
        ></quill-editor>
      </section>
      <section v-else></section>
    </form>
  </side-panel-inner>
</template>

<script>
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.snow.css";
const FileUpload = () => import("@/components/FileUpload");
import { mapState } from "vuex";
export default {
  components: { FileUpload, "quill-editor": quillEditor },
  computed: {
    ...mapState("users", ["currentUser"]),
    section() {
      return this.$route.params.section;
    }
  },
  data() {
    return {
      loading: false,
      quillEditorOptions: {
        modules: {
          toolbar: [
            [{ header: [1, 2, 3, 4, 5, false] }],
            ["bold", "italic", "underline"],
            [{ list: "ordered" }, { list: "bullet" }],
            ["link"]
          ],
          clipboard: {
            matchVisual: false
          }
        },
        formats: ["bold", "italic", "underline", "header", "list", "link"]
      }
    };
  },
  methods: {
    handleQuillInput(res) {
      this.quillEdited = true;
    },

    handleQuillFocus(res) {
      if (!this.quillEdited) {
        res.setSelection(0, 99999);
        this.quillEdited = true;
      }
    },
    onFileUploaded(file) {
      this.currentUser.avatar_id = file.id;
      this.currentUser.avatar = file;
    },
    updateProfile() {
      this.$store
        .dispatch("users/updateProfile")
        .then(resp => {
          //refresh the current user bit
          this.$store.dispatch("auth/listCurrentUser");
          this.$store.dispatch("CLOSE_PANEL");
        })
        .catch(err => {
          console.log("error", { ...err });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ .ql-toolbar {
  background: lightgrey;
}
/deep/ .ql-container {
  background: $colour-nhs-core-white;
  font-size: 16px;

  @media (min-width: 768px) {
    font-size: 13px;
  }
}
</style>
